export const blockIconsActivitiesSelfImprovementNew = (
	<span className='material-symbols-outlined'>self_improvement</span>
);
